var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48285 1.96682L5.58971 1.6331C5.95501 1.52314 6.34783 1.54982 6.69491 1.70817C7.04199 1.86651 7.31961 2.14571 7.47599 2.49367L8.25199 4.21939C8.38668 4.51877 8.42422 4.85282 8.35934 5.17463C8.29447 5.49644 8.13043 5.78985 7.89028 6.01367L6.70914 7.11425C6.55085 7.26453 6.67085 7.85025 7.24914 8.85253C7.82799 9.85539 8.27542 10.252 8.48171 10.1902L10.0291 9.7171C10.3428 9.62116 10.6786 9.62578 10.9895 9.7303C11.3004 9.83482 11.5708 10.034 11.7628 10.3L12.8657 11.8285C13.0885 12.1372 13.1916 12.5162 13.156 12.8952C13.1204 13.2742 12.9484 13.6274 12.672 13.8891L11.8194 14.6965C11.5442 14.9572 11.2048 15.1401 10.8357 15.2268C10.4667 15.3134 10.0813 15.3006 9.71885 15.1897C7.93256 14.6428 6.27828 13.02 4.73371 10.344C3.18571 7.66396 2.60114 5.40339 3.00856 3.55653C3.09074 3.18439 3.27067 2.8409 3.52982 2.56146C3.78896 2.28203 4.11795 2.07676 4.48285 1.96682Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.b337ab01d2f3428e64a3645c7a1fe862.svg";
export { ForwardRef as ReactComponent };